export enum UserPermission {
  GlobalAdmin = 'global_admin',
  GymAdmin = 'gym_admin',
}
